import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Welcome.css';
import bgImage from '../assets/Welcome-BG.jpeg';

const Welcome = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  return (
    <section
      id="home"
      className="welcome-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="container text-center text-white welcome-content">
        <h4 className="welcome-msg">WELCOME TO ONTARIO HOME RENOVATIONS</h4>
        <h1 className="welcome-subtitle">Turning Your Vision Into Reality</h1>
        <p className="welcome-description">
          We deliver reliable, high-quality home renovations with a focus on craftsmanship and
          customer satisfaction. Renovating your home enhances both comfort and value — and we’re
          here to make your vision a reality.
        </p>
        <div className="welcome-buttons mt-4">
          <button
            className="btn btn-primary me-3"
            onClick={() => handleScroll('services')}
          >
            Explore Services
          </button>
          <button
            className="btn btn-outline-light"
            onClick={() => handleScroll('contact')}
          >
            Get Free Estimate
          </button>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
